import axios from "../../../axios";

export const terminate = async (worker_id) => {
  try {
    let { data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/bot/terminate?worker_id=${worker_id}`);
    return data;
  } catch (e) {
    console.log("errors", e);
  }
};
